import React from 'react';

const ThankYouPage = () => {
  return (
    <div>
        <div style={{  marginLeft: "650px", marginTop : "250px" }} className="text-primary">
            <h1 style={{marginLeft: "70px"}}>Thank You!</h1>
            <p>Your all forms have been submitted successfully.</p>
        </div>
    </div>
  );
};

export default ThankYouPage;
